export default __webpack_public_path__ + "static/media/dva.f53fb64f.webp";